// extracted by mini-css-extract-plugin
export default {"container":"playlist_container_IWb5z","content":"playlist_content_DzZNN","details":"playlist_details_bvXDM","title":"playlist_title_siPB7"};